import { forwardRef, type ReactNode } from 'react';
import { createGlobalStyle } from 'styled-components';

/** Width of the outside-grid row-delete gutter (right of the table card). */
export const REVIEW_DOCUMENT_GRID_DELETE_RAIL_WIDTH = 22;

export const ReviewDocumentGridStyles = createGlobalStyle`
  .review-document-grid-layout {
    position: relative;
    display: block;
    width: 100%;
    min-width: 0;
    overflow: visible;
    box-sizing: border-box;
  }

  .review-document-grid-wrap {
    width: 100%;
    min-width: 0;
    border-radius: 8px;
    border: 1px solid var(--color-review-document-surface-border, rgba(219, 234, 227, 0.95));
    background: var(--color-review-document-surface, rgba(255, 255, 255, 0.72));
    overflow: hidden;
  }

  .review-document-grid-toolbar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border-bottom: 1px solid var(--color-review-document-surface-border, rgba(219, 234, 227, 0.95));
    background: var(--color-review-document-surface, rgba(255, 255, 255, 0.72));
  }

  .review-document-grid-toolbar .ant-btn.is-wrap-active {
    color: var(--color-primary, #41aaaf) !important;
    border-color: var(--color-primary, #41aaaf) !important;
    background: color-mix(in srgb, var(--color-primary, #41aaaf) 12%, transparent) !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table {
    table-layout: fixed;
    width: 100%;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table.ant-table-wrapper,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-container,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-header,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-body {
    max-height: none !important;
    overflow-y: visible !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-content {
    overflow-x: auto !important;
    overflow-y: hidden !important;
    scrollbar-width: thin;
    scrollbar-color: var(--color-border, #dbeae3) transparent;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-content::-webkit-scrollbar {
    height: 8px;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-content::-webkit-scrollbar-thumb {
    background: var(--color-border, #dbeae3);
    border-radius: 4px;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-container,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-content,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table table {
    border: none !important;
    background: transparent;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table.ant-table-wrapper,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-container {
    padding: 0 !important;
    margin: 0 !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table table,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-header > table,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-body > table,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-content > table {
    border-collapse: collapse !important;
    border-spacing: 0 !important;
    table-layout: fixed !important;
    width: 100% !important;
    min-width: 100% !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-thead > tr > th,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-tbody > tr > td,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-summary > tr > td,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-cell {
    border-color: var(--color-border, #dbeae3) !important;
    border-style: solid !important;
    border-width: 0 1px 1px 0 !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-thead > tr > th.drawer-table-line-index-col,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-tbody > tr > td.drawer-table-line-index-col {
    border-left-width: 1px !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-thead > tr > th,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-thead .ant-table-cell {
    border-top-width: 1px !important;
    font-size: 10px;
    font-weight: 600;
    line-height: 1.25;
    white-space: normal;
    word-break: break-word;
    hyphens: auto;
    padding: 10px 2px !important;
    vertical-align: top;
    text-align: left;
    background: var(--color-review-document-surface, rgba(255, 255, 255, 0.72)) !important;
    color: var(--color-text-base, #2e2e2e) !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-tbody > tr > td,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-tbody > tr > td.ant-table-cell {
    padding: 0 !important;
    vertical-align: middle;
    background: transparent;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-col-header {
    display: block;
    max-width: 100%;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-col-optional {
    display: block;
    margin-top: 2px;
    font-size: 9px;
    font-weight: 500;
    color: var(--color-text-muted, #9ca8a8);
    line-height: 1.2;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-col-header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    min-width: 0;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-col-header-label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table th.drawer-table-line-index-col,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table td.drawer-table-line-index-col {
    background: var(--color-review-document-surface, rgba(255, 255, 255, 0.72)) !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-line-label {
    display: block;
    font-weight: 600;
    font-size: 10px;
    color: var(--color-primary, #41aaaf);
    text-align: center;
    line-height: 28px;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-tbody > tr > td > div {
    width: 100%;
    margin: 0;
    padding: 0;
    display: block;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-input,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-picker,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-select,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .scope-form-select.ant-select {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    border: none !important;
    box-shadow: none !important;
    box-sizing: border-box !important;
    min-height: 28px !important;
    height: 28px !important;
    background: transparent !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-input,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-picker,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-select .ant-select-selector,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .scope-form-select.ant-select .ant-select-selector {
    min-height: 28px !important;
    height: 28px !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    box-sizing: border-box !important;
    background: transparent !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .scope-form-select.ant-select:hover,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .scope-form-select.ant-select.ant-select-focused,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .scope-form-select.ant-select.ant-select-open,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .scope-form-select.ant-select:hover .ant-select-selector,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .scope-form-select.ant-select.ant-select-focused .ant-select-selector,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .scope-form-select.ant-select.ant-select-open .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-select-arrow {
    color: var(--color-primary, #41aaaf) !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-cell .ant-select {
    width: 100%;
    min-height: 28px !important;
    height: 28px !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-amount-col .ant-input {
    text-align: right;
    padding-left: 2px !important;
    padding-right: 3px !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-summary > tr > td {
    padding: 6px 3px !important;
    vertical-align: middle;
    background: var(--color-review-document-surface, rgba(255, 255, 255, 0.72)) !important;
    overflow: hidden;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .ant-table-summary > tr > td.drawer-table-line-index-col {
    border-left-width: 1px !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-summary-amount {
    display: block;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.25;
    color: var(--color-text-dark, #042a2a);
    text-align: right;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-summary-label {
    display: block;
    padding: 0 6px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.25;
    color: var(--color-text-dark, #042a2a);
    white-space: nowrap;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-discount-col .ant-input,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-tax-col .ant-input {
    padding-left: 1px !important;
    padding-right: 3px !important;
  }

  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-description-col,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-description-col .ant-input,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-description-col .ant-select,
  .review-document-grid-wrap .transaction-edit-drawer-lines-table .drawer-table-description-col .ant-select .ant-select-selector {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0;
    box-sizing: border-box !important;
  }

  .review-document-grid-wrap:not(.is-text-wrap) .transaction-edit-drawer-lines-table .drawer-table-description-col .ant-input {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .ant-table-tbody > tr > td,
  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .ant-table-tbody > tr > td.ant-table-cell {
    vertical-align: top;
  }

  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .drawer-table-line-label {
    line-height: 1.25;
    padding: 6px 0;
  }

  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .drawer-table-text-col .ant-input,
  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .drawer-table-text-col textarea.ant-input {
    height: auto !important;
    min-height: 28px !important;
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: pre-wrap !important;
    word-break: break-word !important;
    line-height: 1.35 !important;
    padding: 4px 6px !important;
    resize: none;
  }

  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .drawer-table-text-col .ant-select,
  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .drawer-table-text-col .scope-form-select.ant-select,
  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .drawer-table-text-col .ant-select .ant-select-selector,
  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .drawer-table-text-col .scope-form-select.ant-select .ant-select-selector {
    height: auto !important;
    min-height: 28px !important;
  }

  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .drawer-table-text-col .ant-select .ant-select-selector,
  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .drawer-table-text-col .scope-form-select.ant-select .ant-select-selector {
    align-items: flex-start !important;
    padding-top: 4px !important;
    padding-bottom: 4px !important;
    white-space: normal !important;
  }

  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .drawer-table-text-col .ant-select-selection-item,
  .review-document-grid-wrap.is-text-wrap .transaction-edit-drawer-lines-table .drawer-table-text-col .ant-select-selection-placeholder {
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: normal !important;
    word-break: break-word !important;
    line-height: 1.35 !important;
    max-width: 100% !important;
  }

  .review-document-grid-delete-rail {
    position: absolute;
    top: 0;
    left: calc(100% + 6px);
    width: ${REVIEW_DOCUMENT_GRID_DELETE_RAIL_WIDTH}px;
    bottom: 0;
    z-index: 3;
    pointer-events: none;
  }

  .review-document-grid-delete-slot {
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 2px;
    pointer-events: auto;
    border-radius: 4px;
  }

  .review-document-grid-delete-slot[data-active='true'],
  .review-document-grid-delete-slot:hover {
    background: var(--color-primary-soft, #e8f3f6);
  }

  .review-document-grid-delete-slot .drawer-table-delete-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 4px;
    background: transparent;
    box-shadow: none;
    color: var(--color-text-muted, #5a6a6a);
    font-size: 13px;
    line-height: 1;
    cursor: pointer;
  }

  @media (hover: hover) and (pointer: fine) {
    .review-document-grid-delete-slot .drawer-table-delete-btn {
      opacity: 0;
      pointer-events: none;
    }

    .review-document-grid-delete-slot[data-active='true'] .drawer-table-delete-btn,
    .review-document-grid-delete-slot:hover .drawer-table-delete-btn,
    .review-document-grid-delete-slot .drawer-table-delete-btn:focus-visible {
      opacity: 1;
      pointer-events: auto;
    }
  }

  .review-document-grid-delete-slot .drawer-table-delete-btn:hover:not(:disabled) {
    color: var(--color-text-dark, #042a2a);
  }

  .review-document-grid-delete-slot .drawer-table-delete-btn:focus-visible {
    outline: 2px solid var(--color-primary, #41aaaf);
    outline-offset: 1px;
    opacity: 1;
    pointer-events: auto;
  }

  .review-document-grid-delete-slot .drawer-table-delete-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const ReviewDocumentGridLayout = forwardRef<
  HTMLDivElement,
  { children: ReactNode }
>(({ children }, ref) => (
  <>
    <ReviewDocumentGridStyles />
    <div ref={ref} className="review-document-grid-layout">
      {children}
    </div>
  </>
));
ReviewDocumentGridLayout.displayName = 'ReviewDocumentGridLayout';

export const ReviewDocumentGridWrap = forwardRef<
  HTMLDivElement,
  { children: ReactNode; textWrap?: boolean }
>(({ children, textWrap }, ref) => (
  <div
    ref={ref}
    className={`review-document-grid-wrap${textWrap ? ' is-text-wrap' : ''}`}
  >
    {children}
  </div>
));
ReviewDocumentGridWrap.displayName = 'ReviewDocumentGridWrap';

export const ReviewDocumentGridToolbar = ({ children }: { children: ReactNode }) => (
  <div className="review-document-grid-toolbar">{children}</div>
);

export const ReviewDocumentGridDeleteRail = forwardRef<
  HTMLDivElement,
  { children: ReactNode }
>(({ children }, ref) => (
  <div ref={ref} className="review-document-grid-delete-rail">
    {children}
  </div>
));
ReviewDocumentGridDeleteRail.displayName = 'ReviewDocumentGridDeleteRail';

export const ReviewDocumentGridDeleteSlot = ({
  rowKey,
  children,
  onMouseEnter,
  onMouseLeave,
}: {
  rowKey: string;
  children: ReactNode;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}) => (
  <div
    className="review-document-grid-delete-slot"
    data-delete-rail-slot
    data-row-key={rowKey}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    {children}
  </div>
);
